// extracted by mini-css-extract-plugin
export default {"card":"F6-z"};